import React, { useState, useRef, useEffect } from "react";
import newsearchfilter from "./SearchFilterNew.scss";
import { useFilter } from "./TagFilterContext";
import Button from "components/base/Button";
import { ReactSVG } from "react-svg";
import SearchArrow from '../../../../assets/images/close-icon-gray.svg';
import { Col, Row } from "react-bootstrap/lib";


const tagSuggestions = ["pre-foreclosure", "sheriff's sale", "auction",
  "date", "time", 'distressed', 'bank', 'bankruptcy',
  'chapter 7', 'chapter 13', 'active', 'dismissed', 'broke', 'liquidation',
  'cash', 'money', 'investors', 'buyer', 'divorce', 'seperation',
  'mls', 'listings', 'removed', 'failure', 'failed', 'fail',
  'flip', 'flippers', 'sold', 'no debt', 'no mortgage', 'paid off',
  'clear', 'debt free', 'equity', 'high equity', 'low debt', 'liens', 'involuntary',
  'listed', 'sale', 'for sale', 'agent', 'realtor',
  'pending', 'contingent', 'lis pendens', 'default', 'notice', "trustee's sale", 'foreclosure',
  'probate', 'pre-probate', 'funeral',
  'cemetary', 'deceased', 'owner', 'transfer', 'Senior Owners', 'senior', 'old',
  'reverse mortgage', 'age', 'delinquency', 'delinquent', 'federal',
  'property', 'property taxes', 'tax', 'taxes', 'unpaid', 'landlord',
  'non-owner', 'non-owner occupied', 'nonowner', 'rental', 'tenant', 'tired',
  'negative equity', 'underwater', 'vacant', 'usps', 'vacation',
  'home', 'empty', 'land', 'plot', 'lot', 'zombie', 'rent', 'for rent',
  'never listed', 'status', 'dom', 'days on market', 'amount', 'price', 'cost',
  'below market value', 'under', 'value', 'description', 'ownership', 'length of time',
  'individual', 'corporate', 'mixed', 'trust', 'local', 'out of state', 'out of county',
  'state', 'county', 'prior', 'linked properties', 'properties', 'multiple', 'unknown',
  'family', 'exchange', 'no sale', 'intra-family', 'exemption', 'disabled', 'homestead',
  'hospital', 'library', 'religious', 'school', 'utilities', 'veteran', 'welfare',
  'widow', 'no exemption', 'mortgage', 'loan', 'conventional', 'fha', 'va',
  'credit line', 'commercial', 'construction', 'debt', 'loan position', 'origination',
  'payment', 'loan term', 'term', 'interest', 'freddie mac', 'fixed', 'adjustable',
  'variable', 'step interest', 'estimated value', 'ratio', 'percentage', 'carryback',
  'seller financing', 'finance', 'owner financing', 'purchase-money', 'comps', 'assessed',
  'analytics', 'increase', 'decrease', 'income', 'cash flow', 'estimate', 'revenue',
  'before taxes', 'expenses', 'estimated', 'medium equity', 'low equity',
  'under water', 'upside down', 'medium', 'high', 'low', 'assessed value', 'improvement',
  'renovate', 'recording', 'trustee', 'cancelled', 'canceled', 'date time', 'release',
  'lien', 'hoa', 'mechanics', 'utility', 'solar', 'child support', 'voluntary', 'city',
  'released', 'recorded', 'seperated', 'court', '100+', 'storage', 'room', 'adu', 'basement',
  'garage', 'cars', 'truck', 'van', 'swimming', 'pool', 'water', 'coa', 'association', 'monthly',
  'fees', 'building', 'second', 'stories', 'tall', 'floors', 'apartment', 'multi-family', 'units',
  'complex', 'district', 'kid', 'child', 'built', 'size', 'sqft', 'area', 'dimensions', 'parcel',
  'shower', 'toilet', 'bathroom', 'plumbing', 'bedroom', 'sleep', '5+', 'abandoned', 'administration',
  'administrative', 'agricultural', 'airport', 'amusement', 'appliance', 'apt', 'arcades', 'arenas',
  'art', 'assembly', 'asylum', 'auditoriums', 'auto', 'bakery', 'bar', 'barren', 'beach', 'bed', 'billiard',
  'boarding', 'boat', 'bottling', 'bowling', 'breakfast', 'brewery', 'bridges', 'bungalow', 'bus terminal', 'cabin',
  'cable tv', 'campground', 'camps', 'cannery', 'carwash', 'casino', 'centrally assessed',
  'charitable', 'charity', 'chemical', 'children', 'church', 'classifications', 'clinic', 'clubs', 'cluster', 'cocktail',
  'cold storage', 'college', 'communications', 'community', 'condo', 'condominium',
  'contaminated', 'contracting', 'contractor', 'convalescent', 'convenience store', 'convention', 'cooperative', 'correctional',
  'country club', 'crematorium', 'crops', 'cultural', 'dairy', 'dance', 'daycare', 'dental', 'department', 'desert',
  'development', 'diner', 'discount', 'distillery', 'dormitory', 'drive-in', 'drive-thru',
  'drug store', 'dry cleaner', 'dump', 'duplex', 'dwelling', 'emergency', 'enterprise', 'entertainment', 'exempt', 'factory', 'fairgrounds',
  'farm', 'fast food', 'fastfood', 'feedlots', 'financial', 'fire', 'florist', 'forest', 'foundry', 'franchise', 'fraternity', 'freeway',
  'fuel', 'game', 'garden', 'gas', 'gasoline', 'go-carts', 'golf', 'golf course', 'government', 'governmental', 'grain',
  'grazing', 'greenhouse', 'grocery', 'group', 'grove', 'gym', 'handicap', 'harbor', 'health', 'healthcare', 'heavy', 'high-rise', 'highway', 'historical',
  'horse', 'horticulture', 'hotel', 'ice', 'industrial', 'insane', 'institution', 'institutional', 'insurance',
  'irrigation', 'jail', 'junk', 'kennel', 'labor', 'laboratory', 'landominium', 'laundromat', 'laundry', 'legal', 'light', 'liquor',
  'livestock', 'lodging', 'loft', 'lounge', 'low income', 'lumber', 'lumberyard', 'mall', 'manufactured', 'manufacturing', 'marina', 'marsh', 'meadow',
  'medical', 'microwave', 'military', 'mill', 'mini-warehouse', 'miniature', 'mining', 'misc', 'mixed use', 'mobile',
  'modular', 'mortuary', 'motel', 'motor freight', 'mountain', 'multi-family', 'multi-tenant', 'municipal', 'municipality',
  'museums', 'native', 'native american', 'natural resources', 'neighborhood', 'nightclub', 'nursery', 'nursing', 'office', 'open space', 'orchard',
  'organization', 'orphanage', 'outdoor', 'packing', 'paper', 'park', 'parking', 'parlor', 'parochial', 'pasture', 'patio', 'personal', 'pet', 'petroleum',
  'pharmacy', 'photo', 'picnic', 'piers', 'plant', 'playground', 'plaza', 'police', 'pollution', 'post office', 'poultry',
  'pre-fabricate', 'pre-school', 'printer', 'printing', 'prison', 'private', 'private preserve', 'professional', 'public',
  'publishing', 'PUD', 'quadruplex', 'quarries', 'quarry', 'quarters', 'race', 'racquet', 'radio station', 'railroad', 'ranch', 'range', 'real estate',
  'recreation', 'recreational', 'recycling', 'redevelopment', 'refinery', 'rentals', 'repair', 'reservoir', 'residence', 'residential', 'resort',
  'restaurant', 'retail', 'retired', 'riding', 'roller', 'rooming', 'row house', 'rural', 'rv', 'sales', 'salvage', 'sbe', 'seasonal',
  'services', 'sewage', 'shipyard', 'shooting', 'shopping', 'shore', 'single family', 'skating', 'skyscraper', 'slaughter house', 'social', 'social services',
  'sorority', 'spa', 'special assessments', 'special purpose', 'stadiums', 'station', 'stockyard', 'sugar', 'supermarket', 'supplies',
  'supply', 'swamp', 'swimming', 'take-out', 'target', 'tavern', 'telegraph', 'telephone', 'tennis', 'theater', 'timberland',
  'timeshare', 'tourist', 'townhouse', 'trailer park', 'trails', 'transient', 'transportation', 'treatment', 'trees', 'triplex',
  'tv station', 'types', 'under construction', 'unimproved', 'university', 'unusable land', 'vacant land',
  'vehicle', 'veterinary', 'village', 'vineyard', 'warehouse', 'wash', 'waste', 'waste land', 'water supply', 'waterslides',
  'well', 'wharf', 'wholesale', 'wildlife', 'winery', 'wood', 'worship', 'yacht', 'zero lot line', 'zoo'];
// const tagSuggestions = ["pre-foreclosure", "sheriff's sale"];

const FilterSearchBar = () => {
  const { addTag, selectedTags, removeTag, clearTags } = useFilter();
  const [tagSearchTerm, setTagSearchTerm] = useState("");
  const [isTagFocused, setIsTagFocused] = useState(false);
  const searchRef = useRef(null);

  const handleChange = (e) => {
    setTagSearchTerm(e.target.value);
    setIsTagFocused(true);
  };

  const handleClearClick = () => {
    setTagSearchTerm("");
    setIsTagFocused(false);
    clearTags()
  };

  const handleRemoveTag = (tag) => {
    removeTag(tag);
  };

  const handleTagClick = (tag) => {
    addTag(tag);
    setTagSearchTerm("");
    setIsTagFocused(false);
  };

  const handleClickOutsideTag = (event) => {

    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setIsTagFocused(false);
    }
  };

  const normalizeString = (str) => {
    return str.toLowerCase().replace(/[^a-z0-9]/g, '');
  };

  const filteredSuggestions = tagSuggestions
  .filter(tag =>
    normalizeString(tag).includes(normalizeString(tagSearchTerm.replace("dead", "deceased").replace("death", "deceased")))
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideTag);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideTag);
    };
  }, []);

  return (
    <div id="searchBarRef" className={newsearchfilter.clsSearchBox} ref={searchRef}>

      <div>
        <input
          type="text"
          placeholder={selectedTags.length > 0 && !isTagFocused ? "" : "Search Keywords eg: Date, Mortgage"}
          className={newsearchfilter.clsSearchInput}
          value={tagSearchTerm}
          onChange={handleChange}
          onFocus={() => setIsTagFocused(true)}
        />
        <div className={newsearchfilter.clsTagListClearBtn}>
          <Button
            kind="link-default"
            name="clear"
            className={newsearchfilter.clsListClearBtn}
            onClick={handleClearClick}
          >
            <ReactSVG src={SearchArrow} className={newsearchfilter.clsListClearIcon} />
          </Button>
        </div>
      </div>
      <div
        className={
          isTagFocused && selectedTags.length > 0
            ? newsearchfilter.clsSelectedTagsRelative
            : newsearchfilter.clsSelectedTagsAbsolute
        }
      >
        {selectedTags.length > 3 && !isTagFocused ? (
          <>
            {selectedTags.slice(0, 3).map((tag, index) => (
              <button key={index} className={newsearchfilter.clsSelectedTag}>
                {tag}
                <Button
                  kind="link-default"
                  name="clear"
                  className={newsearchfilter.clsListClearBtn}
                  onClick={() => handleRemoveTag(tag)}
                >
                  <ReactSVG src={SearchArrow} className={newsearchfilter.clsListClearIcon} />
                </Button>
              </button>
            ))}
            <span>+{selectedTags.length - 3} more</span>
          </>
        ) : (
          selectedTags.map((tag, index) => (
            <button key={index} className={newsearchfilter.clsSelectedTag}>
              {tag}
              <Button
                kind="link-default"
                name="clear"
                className={newsearchfilter.clsListClearBtn}
                onClick={() => handleRemoveTag(tag)}
              >
                <ReactSVG src={SearchArrow} className={newsearchfilter.clsListClearIcon} />
              </Button>
            </button>
          ))
        )}
      </div>


      {isTagFocused && filteredSuggestions.length === 0 && (
        <ul className={newsearchfilter.clsAutoSearchList}>
          <li

            className={newsearchfilter.clsAutoSearchOption}

          >
            No Results Found
          </li>

        </ul>
      )}

      {isTagFocused && tagSearchTerm.length <= 1 && (
        <ul className={newsearchfilter.clsAutoSearchList}>
          <li

            className={newsearchfilter.clsAutoSearchOption}

          >
            Start typing to see keywords
          </li>

        </ul>
      )}



      {isTagFocused && tagSearchTerm.length > 1 && (
        <ul className={newsearchfilter.clsAutoSearchList}>
          {filteredSuggestions.map((tag, index) => (
            <li
              key={index}
              className={newsearchfilter.clsAutoSearchOption}
              onClick={() => handleTagClick(tag)}
            >
              {tag}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FilterSearchBar;
